import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openEinvoicePreview,
  openPreviewNew
} from "../../../store/actions/detailsDocument/preview";
import LoaderSimple from "../../general/loader";
import VaporDrawer from "../../general/vapor/drawer";

const FulfilmentsActivityAttachments = props => {
  const { activity, setDrawerActivityAttachments } = props;

  const dispatch = useDispatch();

  const detailsDocument = useSelector(state => state.detailsDocument);

  const [selectedAttachment, setSelectedAttachment] = useState({});

  useEffect(() => {
    if (activity && activity.attachments) {
      if (activity.attachments.length === 1) {
        setSelectedAttachment(activity.attachments[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedAttachment && selectedAttachment.id) {
      if (!selectedAttachment.eInvoiceType) {
        dispatch(openPreviewNew(
          selectedAttachment.id,
          1,
          false
        )).then(res => {
          if (res && res.content) {
            setSelectedAttachment({
              ...selectedAttachment,
              preview: res.content
            });
          }
        });
      } else {
        dispatch(openEinvoicePreview(selectedAttachment.id,
          selectedAttachment.eInvoiceType)).then(res => {
          setSelectedAttachment({
            ...selectedAttachment,
            preview: res
          });
        });
      }
    }
  }, [selectedAttachment.id]);

  const renderAttachmentsRows = () => {
    let items = [];
    if (activity && activity.attachments) {
      activity.attachments.map(attachment => {
        return items.push(<div
          className="dbx-fulfilments-drawer-attachments-row"
          onClick={() => {
            setSelectedAttachment(attachment);
          }}
        >
          <div className="dbx-fulfilments-drawer-attachments-row-left">
            <div className="dbx-fulfilments-drawer-attachments-row-icon">
              <FontAwesomeIcon icon={["fal", "file-pdf"]} />
            </div>
            <div className="dbx-fulfilments-drawer-attachments-row-name">
              {attachment.subtitle || attachment.title}
            </div>
          </div>
          <div className="dbx-fulfilments-drawer-attachments-row-right">
            <div
              className="dbx-fulfilments-drawer-attachments-row-download"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <FontAwesomeIcon icon={["fal", "arrow-to-bottom"]} />
            </div>
          </div>
        </div>);
      });
    }
    return items;
  };

  const renderAttachmentPreview = () => {
    if (
      detailsDocument.previewDetails &&
      detailsDocument.previewDetails.status.started
    ) {
      return (
        <div className="dbx-fulfilments-drawer-attachments-preview-loader">
          <LoaderSimple message="Caricamento anteprima..." />
        </div>
      );
    }
    return (
      <div className="dbx-fulfilments-drawer-attachments-preview">
        <div className="dbx-fulfilments-drawer-attachments-preview-header">
          <div className="dbx-fulfilments-drawer-attachments-preview-title">
            <div>
              {activity &&
                activity.attachments &&
                activity.attachments.length > 1 && (
                <FontAwesomeIcon
                  onClick={() => {
                    setSelectedAttachment({});
                  }}
                  icon={["fal", "arrow-left"]}
                />
              )}
            </div>
            <div>{selectedAttachment.subtitle || selectedAttachment.title}</div>
          </div>
          <div className="dbx-fulfilments-drawer-attachments-preview-download">
            <FontAwesomeIcon icon={["fal", "arrow-to-bottom"]} /> Download
          </div>
        </div>
        <div className="dbx-fulfilments-drawer-attachments-preview-img">
          {selectedAttachment &&
            selectedAttachment.preview &&
            !selectedAttachment.eInvoiceType && (
            <img
              src={`data:image/jpeg;base64, ${selectedAttachment.preview}`}
              alt=""
            />
          )}
          {selectedAttachment &&
            selectedAttachment.preview &&
            selectedAttachment.eInvoiceType && (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: selectedAttachment.preview }}
            ></div>
          )}
        </div>
      </div>
    );
  };

  return (
    <VaporDrawer
      title={activity.description}
      visible={true}
      width={900}
      hideFooter
      onClose={() => setDrawerActivityAttachments(false)}
    >
      <div className="dbx-fulfilments-drawer-attachments-root">
        <div className="dbx-fulfilments-drawer-attachments-header">
          Allegati
        </div>
        <div className="dbx-fulfilments-drawer-attachments-rows">
          {!selectedAttachment.id && renderAttachmentsRows()}
          {selectedAttachment.id && renderAttachmentPreview()}
        </div>
      </div>
    </VaporDrawer>
  );
};

export default FulfilmentsActivityAttachments;
